/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Payment_Terms_DescriptionInputs */

const en_clients_payment_terms_description = /** @type {(inputs: Clients_Payment_Terms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure the payment terms allowed in this client’s negotiations.`)
};

const pt_br2_clients_payment_terms_description = /** @type {(inputs: Clients_Payment_Terms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure as condições de pagamento permitidas nas negociações deste cliente.`)
};

/**
* | output |
* | --- |
* | "Configure the payment terms allowed in this client’s negotiations." |
*
* @param {Clients_Payment_Terms_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_payment_terms_description = /** @type {((inputs?: Clients_Payment_Terms_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Payment_Terms_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_payment_terms_description(inputs)
	return pt_br2_clients_payment_terms_description(inputs)
});